import React, { useEffect, useState } from "react";
import useTable from "../../useTableR";
import axios from "axios";
import { Dimmer } from "../../spinner";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { ActualizarComercio } from "./modalActualizarComercio";
import { ImprimirPatente } from "./modalImprimirPatente";
import LicenciaService from "./service/licencia.service";
import ModalRechazarLicencia from "./ModalRechazarLicencia";
import comercioService from "./service/comercio.service";
import { crearBitacora } from "../../../hooks/bitacora";

export const ActualizarLicencia = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const permisoDeclara = JSON.parse(
    localStorage.getItem("permisos"),
  ).accpermdecla;
  const permisosComercio = JSON.parse(
    localStorage.getItem("permisos"),
  ).accexoncomercio;
  const fechaActual = new Date();
  const fechaSistemaObj = fechaActual.toISOString();
  const fechaFormat = new Date().toISOString().split("T")[0];
  const idUsuario = localStorage.getItem("idusuario");
  const idUsuarioLimpio = idUsuario ? idUsuario.replace(/^"|"$/g, "") : null;
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [seleccionarFiltro, setSeleccionarFiltro] = useState("por_aprob");
  const [anioSeleccionado, setAnioSeleccionado] = useState(anioActual);
  const [datosTabla, setDatosTabla] = useState([]);
  const [persona, setPersona] = useState();
  const [statusCome, setStatusCome] = useState();
  const factorCambio = JSON.parse(localStorage.getItem('factorCambio'))
  const [mostrarMotivo, setMostrarMotivo] = useState({
    mostrar: false,
    consulta: false,
  });
  const [motivo, setMotivo] = useState("");
  const [reversar, setReversar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mostrarPatente, setMostrarPatente] = useState(false);
  const [mostrarContri, setMostrarContri] = useState(false);
  const [itemSelect, setItemSelect] = useState({
    index: -1,
    item: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
    reversar: false,
  });
  const [mensajesino2, setMensajesino2] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
    reversar: false,
  });
  const headCells = [
    {
      id: 1,
      label: "N°",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 2,
      label: "Nombre",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 3,
      label: "Rif/Cedula",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 4,
      label: "Dirección",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 5,
      label: "Fecha",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 6,
      label: "Estatus",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 7,
      label: "Opciones",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const filtroBusquea = [
    {
      id: "por_aprob",
      label: "Por Aprobación",
    },
    {
      id: "por_revi",
      label: "Por Revisión",
    },
    {
      id: "por_proce",
      label: "Por Procesar",
    },
    { id: "por_impr_lic", label: "Por Imprimir Licencia" },
    { id: "aprob_impr", label: "Aprobadas Impresas" },
    { id: "aprob_entre", label: "Aprobadas por Entregar" },
    { id: "entregadas", label: "Entregadas" },
    {
      id: "todas",
      label: "Todas",
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idsolicitudregistro.includes(target.value) ||
              x.fechasolicitud
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase()) ||
              x.direccion.toLowerCase().includes(target.value.toLowerCase()) ||
              x.status.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarFila = (item, index) => {
    let per = [];
    per.push({
      nacionalidad: item.cedularepre ? item.cedularepre.substring(0, 1) : "",
      cedula: item.cedularepre
        ? item.cedularepre.substring(1, item.cedularepre.trim().length)
        : "",
      nombres: item.nombre,
      apellidos: "",
      direccion: item.direccion,
      correoe: item.correorepre ? item.correorepre : null,
      tlf1: item.telefonorepre ? item.telefonorepre : null,
      tlf2: item.telefonorepre ? item.telefonorepre : null,
      sexo: item.sexo,
    });
    setPersona(per);
    item.tiponegocio = item.actividadeconomica;
    item.latitud = 0;
    item.longitud = 0;
    setItemSelect({
      index: index,
      item: item,
    });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(datosTabla, headCells, filterFn);
  const buscarRegistros = async () => {
    try {
      setLoading(true);
      const res = await LicenciaService.getAll(
        seleccionarFiltro,
        anioSeleccionado,
      );
      if (res.length > 0) {
        setDatosTabla(res);
      } else {
        setDatosTabla([]);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Buscar Registros",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const obtenerTextoBoton = () => {
    switch (itemSelect.item.estatussolicitud) {
      case 1:
      case 12:
        return "Cambiar Estatus a Revisión";
      case 2:
        return "Cambiar Estatus a por Entregar";
      case 3:
        return "Cambiar Estatus a Entregadas";
      case 10:
        return "Cambiar Estatus a Procesar";
      case 13:
        return "Cambiar estatus a Aprobadas Impresas";
      default:
        return null;
    }
  };
  const validarStatus = (status) => {
    try {
      switch (status) {
        case 1:
        case 12:
          return 10;
        case 2:
          return 3;
        case 3:
          return 4;
        case 10:
          return 11;
        case 11:
          return 13;
        case 13:
          return 2;
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Validar el Estatus de la Licencia",
        icono: "error",
      });
    }
  };
  const obtenerTextoMensaje = (reversar) => {
    let texto = "";
    if (itemSelect.item.estatussolicitud === 13) {
      buscarActividadxComercio();
      return;
    }
    if (reversar) {
      texto = `En este momento la Solicitud de Licencia de Funcionamiento se devolverá para su debida revisión, \n está seguro de devolver?`;
    } else {
      switch (itemSelect.item.estatussolicitud) {
        case 1:
        case 12:
          texto = `En este momento la Solicitud de Licencia de Funcionamiento se enviará para su firma, \n está seguro de enviar?`;
          break;
        case 2:
          texto = `En este momento se procederá a enviar la Solicitud de Licencia de Funcionamiento a Verificación, \n está seguro enviar?`;
          break;
        case 3:
          texto = `En este momento se procederá a enviar la Solicitud de Licencia de Funcionamiento para Procesar, \n está seguro enviar?`;
          break;
        case 10:
          texto = `En este momento se procederá a formalizar la entrega de la Solicitud de Licencia de Funcionamiento, \n está seguro formalizar dicha entrega?`;
          break;
      }
    }

    setMensajesino({
      mostrar: true,
      titulo: "",
      texto: texto,
      icono: "informacion",
      reversar: reversar,
    });
  };
  const buscarActividadxComercio = async () => {
    try {
      const campos = "*";
      const tabla = "actividadxcomercio";
      const condi = `idcomercio = ${itemSelect.item.idcomercio}`;
      const orden = `1`;
      const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${tabla}&condi=${condi}&orden=${orden}`;
      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.status === 200 && res.data.length > 0) {
            setMostrarPatente(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "El Comercio no Cuenta con Tipo Actividad",
              icono: "error",
            });
          }
        })
        .catch((error) => {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "Error al Buscar Registros",
            icono: "error",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Buscar Actividad x Comercio",
        icono: "error",
      });
    }
  };
  const actualizarLicencia = async () => {
    try {
      if (itemSelect.item === "") {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al Actualizar la Licencia",
          icono: "error",
        });
        return;
      }

      const body = [
        {
          idsolicitud: itemSelect.item.idsolicitudregistro,
          fechasolicitud: itemSelect.item.fechasolicitud,
          nombre: itemSelect.item.nombre,
          rif: itemSelect.item.rif,
          direccion: itemSelect.item.direccion,
          estatussolicitud: reversar
            ? "12"
            : validarStatus(itemSelect.item.estatussolicitud),
          estatusnotificacion: reversar ? 1 : 0,
        },
      ];

      if (reversar && motivo === "") {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "El Motivo del Rechazo no Puede estar Vacio",
          icono: "informacion",
        });
        return;
      }

      // Agregar campos solo si es necesario
      if (reversar) {
        body[0].motivorechazo = motivo;
        body[0].rechazodia = fechaSistemaObj;
        body[0].usuariorechaza = parseInt(idUsuarioLimpio, 10);
      }

      setLoading(true);
      const timestamp = fechaSistemaObj;
      const jsonBody = JSON.stringify(body);
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros`;

      await axios
        .get(endpoint, {
          params: {
            campos: "*",
            nomtab: `actualizar_status_solicitud_licencia('${timestamp}', '${jsonBody}'::jsonb)`,
            orden: "1",
          },
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then(async (res) => {
          if (res.status === 200 && res.data && res.data.length > 0) {
            await crearBitacora(
              "ACTUALIZAR ESTATUS DE LICENCIA",
              "solicitudregistro",
              itemSelect.item.idsolicitudregistro,
            );
            setMensaje({
              mostrar: true,
              titulo: "",
              texto: `Licencia N° ${itemSelect.item.idsolicitudregistro} Actualizada Correctamente`,
              icono: "exito",
            });
            setItemSelect({
              index: -1,
              item: "",
            });
            buscarRegistros();
          } else {
            throw new Error("Respuesta vacía del servidor");
          }
        })
        .catch((error) => {
          console.error(
            "Error detallado:",
            error.response?.data || error.message,
          );
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: `Error al Actualizar la Licencia: ${error.response?.data?.message || error.message}`,
            icono: "error",
          });
        })
        .finally(() => {
          setLoading(false);
          setMostrarMotivo({
            mostrar: false,
            consulta: false,
          });
        });
    } catch (error) {
      console.error("Error en catch:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Actualizar la Licencia",
        icono: "error",
      });
    }
  };
  const eliminarLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/industria/eliminar-licencia`;
      axios
        .post(
          endpoint,
          {
            idLicencia: itemSelect.item.idsolicitudregistro,
          },
          {
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "application/json",
            },
          },
        )
        .then(async (res) => {
          if (res.status === 200) {
            await crearBitacora(
              "ELIMINAR LICENCIA",
              "solicitudregistro",
              itemSelect.item.idsolicitudregistro,
            );
            buscarRegistros();
            setItemSelect({
              index: -1,
              item: "",
            });
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Licencia Eliminada Correctamente",
              icono: "exito",
            });
          }
        })
        .catch((err) => {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "Error al Eliminar la Licencia",
            icono: "error",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Eliminar la Licencia",
        icono: "error",
      });
    }
  };
  const imprimirReporte = (id) => {
    try {
      window.open(
        op.reportes +
          "/actividadeconomica?" +
          "reporte=RegistroContribuDeImpuesto" +
          `&ID=${id}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Imprimir la Licencia",
        icono: "error",
      });
    }
  };
  const cerrar = () => {
    blanquear();
    props.onHideCancela();
  };
  const blanquear = () => {
    setDatosTabla([]);
    setSeleccionarFiltro("por_aprob");
    setPersona("");
    setMostrarMotivo({
      mostrar: false,
      consulta: false,
    });
    setMotivo("");
    setReversar(false);
    setLoading(false);
    setMostrarPatente(false);
    setMostrarContri(false);
    setItemSelect({
      index: -1,
      item: "",
    });
  };
  useEffect(() => {
    setItemSelect({
      index: -1,
      item: "",
    });
    buscarRegistros();
  }, [seleccionarFiltro, anioSeleccionado]);
  useEffect(() => {
    seleccionarStatus();
  }, []);
  const seleccionarStatus = async () => {
    try {
      const data = await comercioService.getStatus();
      var come = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].tipostatus.trim() === "COMERCIO") {
          come.push({
            idstatus: data[i].idstatus,
            descripcion: data[i].descripcion,
          });
        }
        setStatusCome(come);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error cargando status",
        icono: "error",
      });
    }
  };
  return (
    <div
      className="mx-5 border-table"
      style={{
        marginTop: "3.5%",
      }}
    >
      <div className="py-0 text-uppercase">
        <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between text-light border-bottom">
          <h3 className="fw-bold text-light m-0">
            Solicitudes de Licencia de Funcionamiento de Actividades Económicas.
          </h3>
          <button onClick={() => cerrar()} className="btn btn-sm bg-light">
            <i className="fa fa-times"></i>
          </button>
        </header>
        <div className="d-flex justify-content-between mx-1 px-1">
          <div className="col-3 input-group input-group-sm m-1 p-1 mr-auto">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
              placeholder="Buscar Licencia..."
            />
          </div>
          <div className="col-md-3 mr-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Buscar por:
              </span>
              <select
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                value={seleccionarFiltro}
                onChange={(e) => {
                  setSeleccionarFiltro(e.target.value);
                }}
              >
                {filtroBusquea.map((e, index) => (
                  <option key={index} value={e.id}>
                    {e.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-1 ml-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Año
              </span>
              <select
                type="text"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                value={anioSeleccionado}
                onChange={(e) => setAnioSeleccionado(e.target.value)}
              >
                {anios.map((e, index) => (
                  <option key={index} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <div style={{ maxHeight: "350px", overflowY: "auto" }}>
            <TblContainer>
              <TblHead />
              <tbody>
                {datosTabla && recordsAfterPagingAndSorting().length > 0 ? (
                  // Mostrar registros existentes
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        padding: "0",
                        cursor: "pointer",
                        background:
                          itemSelect.index === index ? "lightskyblue" : "white",
                      }}
                      onClick={(e) => {
                        seleccionarFila(item, index);
                      }}
                    >
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "50px",
                        }}
                      >
                        {item.idsolicitudregistro}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "left",
                          width: "auto",
                        }}
                      >
                        {item.nombre}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "120px",
                        }}
                      >
                        {item.rif}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "left",
                          width: "auto",
                        }}
                      >
                        {item.direccion}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "50px",
                        }}
                      >
                        {
                          new Date(item.fechasolicitud)
                            .toISOString()
                            .split("T")[0]
                        }
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "150px",
                        }}
                      >
                        {item.status}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "120px",
                        }}
                      >
                        {item.estatussolicitud === 12 && (
                          <button
                            type="button"
                            title="Ver Motivo del Rechazo"
                            style={{ fontSize: "11px" }}
                            className="btn btn-warning btn-sm rounded-pill mx-1"
                            onClick={() => {
                              seleccionarFila(item, index);
                              setMostrarMotivo({
                                mostrar: true,
                                consulta: true,
                              });
                            }}
                          >
                            <i className="fa fa-info-circle" />
                          </button>
                        )}
                        <button
                          type="button"
                          title="Ver Licencia"
                          style={{ fontSize: "11px" }}
                          className="btn btn-info btn-sm rounded-pill mx-1"
                          onClick={() =>
                            imprimirReporte(item.idsolicitudregistro)
                          }
                        >
                          <i className="fa fa-print" />
                        </button>
                        {(item.estatussolicitud === 12 ||
                          item.estatussolicitud === 1) && (
                          <button
                            type="button"
                            title="Eliminar la Licencia"
                            style={{ fontSize: "11px" }}
                            className="btn btn-danger btn-sm rounded-pill mx-1"
                            onClick={() => {
                              seleccionarFila(item, index);
                              setMensajesino2({
                                mostrar: true,
                                titulo: "",
                                texto: `Esta Seguro de Eliminar la Licencia N° ${item.idsolicitudregistro}?`,
                                icono: "informacion",
                              });
                            }}
                          >
                            <i className="fa fa-trash" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        fontSize: "12px",
                        color: "#666",
                      }}
                    >
                      No hay registros disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </TblContainer>
          </div>
          <TblPagination />
        </div>
        <div className="d-flex justify-content-end m-2 gap-2">
          {itemSelect.item !== "" &&
            itemSelect.item.estatussolicitud === 10 && (
              <button
                type="button"
                style={{ fontSize: "11px" }}
                className="btn btn-danger btn-sm rounded-pill"
                disabled={itemSelect.item === ""}
                onClick={() => {
                  obtenerTextoMensaje(true);
                  setReversar(true);
                }}
              >
                <i className="fa fa-refresh">
                  Devolver Status a Por Aprobación
                </i>
              </button>
            )}
          {obtenerTextoBoton() !== null && (
            <button
              type="button"
              style={{ fontSize: "11px" }}
              className="btn btn-info btn-sm rounded-pill"
              disabled={itemSelect.item === ""}
              onClick={() => {
                obtenerTextoMensaje(false);
                setReversar(false);
              }}
            >
              <i className="fa fa-refresh">{obtenerTextoBoton()}</i>
            </button>
          )}
          {itemSelect.item !== "" &&
            itemSelect.item.estatussolicitud === 11 && (
              <button
                type="button"
                style={{ fontSize: "11px" }}
                className="btn btn-success btn-sm rounded-pill"
                disabled={itemSelect.item === ""}
                onClick={() => setMostrarContri(true)}
              >
                <i className="fa fa-check"> Procesar Solicitud</i>
              </button>
            )}
        </div>
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={() => {
            mensajesino.reversar
              ? setMostrarMotivo({
                  mostrar: true,
                  consulta: false,
                })
              : actualizarLicencia();
            setMensajesino({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino2}
          onHideNo={() =>
            setMensajesino2({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            })
          }
          onHideSi={() => {
            eliminarLicencia();
            setMensajesino2({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
          }}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={loading} inverted />
        <ActualizarComercio
          show={mostrarContri}
          onHideCancela={() => setMostrarContri(false)}
          onHideAcepta={() => {
            setMostrarContri(false);
            actualizarLicencia();
          }}
          comercio={itemSelect.item}
          factorCambio={factorCambio?.valor}
          usuarioweb={""}
          statuscome={statusCome}
          representante={""}
          actividadcome={{
            idactividad: 1,
          }}
          tabactixcomer={[]}
          inmueble={""}
          tabdeuda={""}
          tabpago={""}
          tabpagow={""}
          tabreten={""}
          ingresa={itemSelect.item?.idsolicitudregistro}
          declaweb={"false"}
          idusuario={idUsuarioLimpio}
          operacion={1}
          operacionper={0}
          permisodecla={permisoDeclara}
          permisoexon={permisosComercio}
          licencia={true}
        />
        <ImprimirPatente
          show={mostrarPatente}
          onHideCancela={() => setMostrarPatente(false)}
          onHideAcepta={() => {
            setMostrarPatente(false);
            actualizarLicencia();
          }}
          idcomercio={itemSelect.item.idcomercio}
          licencia={true}
        />
        <ModalRechazarLicencia
          show={mostrarMotivo.mostrar}
          onHide={() =>
            setMostrarMotivo({
              mostrar: false,
              consulta: false,
            })
          }
          setMotivo={(e) => setMotivo(e)}
          onHideAcepta={() => actualizarLicencia()}
          consulta={mostrarMotivo.consulta}
          revisado={
            `${itemSelect.item.nombre_persona}` +
            " " +
            `${itemSelect.item.apellido_persona}`
          }
          motivo={itemSelect.item.motivorechazo}
          fecha={itemSelect.item.rechazodia}
        />
      </div>
    </div>
  );
};
